import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FrontpageEndpoint } from './frontpage-endpoint';

@Injectable({
  providedIn: 'root',
})
export class FrontpageRoutingResolver
  
{
  constructor(private http: HttpClient) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.http.get(route.data.dataUrl).pipe(
      catchError((err) => {
        console.error(err);
        return EMPTY;
      })
    );
  }
}
